/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$anchor-navigation-icons-radius: 2px !default;
$anchor-navigation-default-radius: 0px !default;
$anchor-navigation-default-shadow: rgb(0 0 0 / 15%) 0px 4px 8px 0px !default;
$anchor-navigation-hover-shadow: 0px 0px 24px rgba(0, 0, 0, 0.2) !default;
$anchor-navigation-max-content-width: $breakpoint-desktop-l !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

.#{$prefix}anchor-nav {
  position: absolute;
  font-weight: 700;
  width: 0;
  height: 100vh;
  left: 0;
  top: var(--initPosition);
  user-select: none;
  z-index: 99;

  &.#{$prefix}fix {
    position: fixed;
    top: var(--fixPosition);
  }

  @media (min-width: ($anchor-navigation-max-content-width + calc(240px * 2))) {
    transform: translateX(calc(-1 * #{$anchor-navigation-max-content-width} * 0.5 - 240px));
    left: 50%;

    .#{$prefix}anchor-nav__list {
      min-width: 240px;
      padding: 20px 0;
      border-radius: 14px;
    }

    .#{$prefix}anchor-nav__item {
      max-width: none;
    }
  }

  &__wrapper {
    position: absolute;
    border-radius: $anchor-navigation-default-radius;
  }

  &__list {
    position: relative;
    width: 48px;
    min-width: 48px;
    padding: 32px 0 32px 16px;
    margin: 0;
    background-color: $anchor-navigation-background-color;
    transition: all 0.3s ease-out;
    list-style: none;
    border-radius: 0px 14px 14px 0px;
    box-shadow: $anchor-navigation-default-shadow;

    @include for-size(tablet-or-larger) {
      padding: 30px 0;
    }

    &:hover,
    &:focus-visible,
    &:focus-within {
      background-color: $anchor-navigation-background-hover-color;
      min-width: 240px;
      transition: background-color 0.2s linear, min-width 0.2s linear;
      box-shadow: $anchor-navigation-hover-shadow;

      .#{$prefix}anchor-nav__link {
        max-width: 240px;
      }

      .#{$prefix}anchor-nav__item {
        max-width: 240px;
      }
    }

    @include for-size(tablet) {
      width: 24px;
      min-width: 24px;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: -24px; 
        width: 24px;
        height: 100%;
      }
    }
  }

  &__item {
    cursor: pointer;
    display: flex;
    max-width: 48px;
    padding: 0 4px;
    transition: max-width 0.2s linear, background 0.2s linear;
    overflow: hidden;

    @include for-size(tablet-or-larger) {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    &--active {
      .#{$prefix}anchor-nav__icon {
        background: $anchor-navigation-icon-highlight-color;
        min-width: 8px;
        max-width: 8px;
        height: 16px;
      }

      .#{$prefix}anchor-nav__link {
        color: $anchor-navigation-link-highlight-color;
      }

      .#{$prefix}anchor-nav__container {
        &:hover,
        &:focus-visible {
          .#{$prefix}anchor-nav__icon--active {
            background: $anchor-navigation-icon-hover-color;
          }

          .#{$prefix}achor-nav__link {
            color: $anchor-navigation-link-hover-color;
          }
        }
      }
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__container {
    cursor: pointer;
    border-style: none;
    border-radius: 4px;
    outline: none;
    align-items: center;
    text-align: left;
    padding: 0;
    background-color: $anchor-navigation-item-background-color;
    display: grid;
    grid-template-columns: 48px auto;
    width: 100%;
    transition: max-width 0.2s linear, background 0.2s linear;

    @include for-size(tablet){
      grid-template-columns: 36px auto;
    }
  }

  &__container {
    @media (min-width: ($anchor-navigation-max-content-width + 240px)) {
      max-width: 240px;
    }

    &:hover,
    &:focus-visible {
      background: $anchor-navigation-item-hover-color;

      .#{$prefix}anchor-nav__container {
        background: $anchor-navigation-item-hover-color;
      }

      .#{$prefix}anchor-nav__link {
        color: $anchor-navigation-link-hover-color;
      }

      .#{$prefix}anchor-nav__icon {
        background: $anchor-navigation-icon-hover-color;

        &--active {
          background: $anchor-navigation-icon-highlight-color;
        }
      }
    }

    &:hover {
      .#{$prefix}anchor-nav__link {
        text-decoration: underline;
      }
    }

    .#{$prefix}anchor-nav__icon {
      margin-left: 16px;

      @include for-size(tablet) {
        margin-left: 4px;
      }

      &--active {
        background: $anchor-navigation-icon-highlight-color;
      }
    }
  }

  &__icon {
    position: relative;
    display: block;
    min-width: 8px;
    max-width: 8px;
    height: 8px;
    border-radius: $anchor-navigation-icons-radius;
    background: $anchor-navigation-icon-color;
    transition: all 0.2s linear;

    @include for-size(tablet-or-larger) {
      margin-left: 0;
    }
  }

  &__link {
    font-family: $font-family-base;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    min-width: 180px;
    margin-left: -4px;
    padding: 4px 8px 4px 0;
    align-items: center;
    overflow: hidden;
    color: $anchor-navigation-link-color;
    text-decoration: none;
    white-space: break-spaces;
    font-weight: #{$font-weight-medium};
    line-height: 27px;
    font-size: 18px;
  }
}
